import { componentProvider } from 'js-component-framework';
import printPowerWords from './print-power-words';

/**
 *
 * @type {{name: string, querySelector: {container: string, button: string}, class: printPowerWords}}
 */
const printPowerWordsConfig = {
  name: 'print-power-words',
  component: printPowerWords,
  querySelector: {
    sectionContainer: '.power-words-container',
    ppwButton: '.print-power-words-btn',
  },
};

componentProvider(printPowerWordsConfig);
